import React, { useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import logo from '../../images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { register } from "../../Api/authApi.js.js";

const flagsStyle = `
.auth-flags button {
    background: rgba(255,255,255,0.05) !important;
    border: 1px solid rgba(255,255,255,0.08) !important;
    border-radius: 14px !important;
    color: #F2F5FB !important;
    padding: 14px 16px !important;
    font-size: 15px !important;
    width: 100%;
}
.auth-flags ul {
    background: #14213D !important;
    border: 1px solid rgba(255,255,255,0.08) !important;
    border-radius: 12px !important;
}
.auth-flags li { color: #F2F5FB !important; }
.auth-flags li:hover { background: rgba(255,255,255,0.06) !important; }
.auth-flags input {
    background: rgba(255,255,255,0.05) !important;
    color: #F2F5FB !important;
    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
}
`;

const inputStyle = {
    width: '100%', background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14, color: '#F2F5FB', fontSize: 15,
    padding: '14px 44px 14px 42px', outline: 'none',
    boxSizing: 'border-box',
};

function EyeIcon({ open }) {
    return open ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
        </svg>
    ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
        </svg>
    );
}

const SignUpPage = () => {
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        username: '', email: '', password: '',
        password_confirmation: '', team_code: '', country: 'FR',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleCountrySelect = (code) => setUserData({ ...userData, country: code });
    const handleChange = (e) => setUserData({ ...userData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await register(userData);
            setUserData({ username: '', email: '', password: '', password_confirmation: '', team_code: '', country: 'FR' });
            toast.success('Vous avez créé votre compte avec succès !');
            navigate('/connexion');
        } catch (error) {
            if (error.response?.data?.errors) {
                Object.values(error.response.data.errors).forEach((msgs) =>
                    msgs.forEach((msg) => toast.warning(msg))
                );
            } else {
                toast.warning('Une erreur est survenue');
            }
        }
    };

    return (
        <>
            <style>{flagsStyle}</style>
            <div style={{
                minHeight: '100vh', background: '#0A1226',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                padding: '80px 24px 40px',
                WebkitFontSmoothing: 'antialiased',
                position: 'relative',
            }}>
                {/* Bouton retour */}
                <div style={{ position: 'absolute', top: 20, left: 20 }}>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <button style={{
                            width: 38, height: 38, borderRadius: 12,
                            background: 'rgba(255,255,255,0.06)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            display: 'grid', placeItems: 'center',
                            cursor: 'pointer', color: '#F2F5FB', padding: 0,
                        }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </Link>
                </div>

                <div style={{ width: '100%', maxWidth: 360 }}>
                    {/* Logo */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
                        <img src={logo} alt="Trading Series" style={{ height: 48, width: 'auto' }} />
                    </div>

                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {/* Nom d'utilisateur */}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                                </svg>
                            </span>
                            <input
                                type="text" name="username" value={userData.username}
                                onChange={handleChange} placeholder="Nom d'utilisateur"
                                required style={inputStyle}
                            />
                        </div>

                        {/* Email */}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                                <svg width="16" height="16" viewBox="0 0 20 16" fill="currentColor">
                                    <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z"/>
                                    <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z"/>
                                </svg>
                            </span>
                            <input
                                type="email" name="email" value={userData.email}
                                onChange={handleChange} placeholder="Adresse e-mail"
                                required style={inputStyle}
                            />
                        </div>

                        {/* Mot de passe */}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                            </span>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password" value={userData.password}
                                onChange={handleChange} placeholder="Mot de passe"
                                required style={inputStyle}
                            />
                            <button type="button" onClick={() => setShowPassword(v => !v)} style={{
                                position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                                background: 'none', border: 'none', cursor: 'pointer', color: '#5C6B88', padding: 0, display: 'flex',
                            }}>
                                <EyeIcon open={showPassword} />
                            </button>
                        </div>

                        {/* Confirmation mot de passe */}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                            </span>
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                name="password_confirmation" value={userData.password_confirmation}
                                onChange={handleChange} placeholder="Confirmation du mot de passe"
                                required style={inputStyle}
                            />
                            <button type="button" onClick={() => setShowConfirmPassword(v => !v)} style={{
                                position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                                background: 'none', border: 'none', cursor: 'pointer', color: '#5C6B88', padding: 0, display: 'flex',
                            }}>
                                <EyeIcon open={showConfirmPassword} />
                            </button>
                        </div>

                        {/* Pays */}
                        <div className="auth-flags">
                            <ReactFlagsSelect
                                selected={userData.country || 'FR'}
                                defaultCountry="FR"
                                onSelect={handleCountrySelect}
                                searchable
                            />
                        </div>

                        {/* Code équipe */}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
                                </svg>
                            </span>
                            <input
                                type="number" name="team_code" value={userData.team_code}
                                onChange={handleChange} placeholder="Code de l'équipe"
                                style={inputStyle}
                            />
                        </div>

                        <button type="submit" style={{
                            marginTop: 4, height: 54, borderRadius: 16, width: '100%',
                            background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                            color: '#0A1226', border: 'none', cursor: 'pointer',
                            fontWeight: 700, fontSize: 15,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
                            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 10px 24px -10px rgba(0,0,0,0.6)',
                        }}>
                            Créer mon compte
                        </button>
                    </form>

                    <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#5C6B88' }}>
                        Déjà un compte ?{' '}
                        <Link to="/connexion" style={{ color: '#97A4BE', fontWeight: 600, textDecoration: 'none' }}>
                            Se connecter
                        </Link>
                    </p>
                </div>
            </div>
        </>
    );
};

export default SignUpPage;
